import axios from 'axios';

export default class OrderItemsActions {
  constructor(resource, publicUrl, customConfig) {
    this.publicUrl = publicUrl;
    this.resource = resource;
    this.customConfig = customConfig;
  }

  getByOrder(idPublic) {
    return axios.get(
      `${this.publicUrl}orders/${idPublic}/${this.resource}`,
      this.customConfig
    );
  }

  getByOrderWithWorkOrderItemOrderItems(idPublic) {
    return axios.get(
      `${this.publicUrl}orders/${idPublic}/${this.resource}?include=workorderitemorderitems`,
      this.customConfig
    );
  }
}
